import * as DialogPrimitive from "@radix-ui/react-dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { XIcon } from "lucide-react";
import { cn } from "~/lib/utils";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "../ui/dialog";
import BarcodeScannerComponent from "./qrcode-scanner";

interface Params {
  onQRCodeScanned: (data: string) => void;
}

const QRCodeDialog = ({
  onQRCodeScanned,
  onOpenChange,
  ...props
}: React.ComponentProps<typeof DialogPrimitive.Root> & Params) => {
  return (
    <Dialog onOpenChange={onOpenChange} {...props}>
      <VisuallyHidden>
        <DialogTitle>Leitor de QR Code</DialogTitle>
        <DialogDescription>
          Realiza a leitura do QR code de uma obra.
        </DialogDescription>
      </VisuallyHidden>
      <DialogContent className="w-full h-full">
        <div
          className={cn(
            "border-8 border-primary self-center justify-self-center w-3/4 aspect-square"
          )}
        >
          <BarcodeScannerComponent
            width={500}
            height={500}
            delay={200}
            onUpdate={(err, result) => {
              if (!result) return;
              onQRCodeScanned(result.getText());
              if (onOpenChange) onOpenChange(false);
            }}
          />
        </div>
        <Button
          size="iconlg"
          variant="outline"
          className="bg-primary absolute bottom-4 right-4"
          onClick={() => {
            if (onOpenChange) onOpenChange(false);
          }}
        >
          <div className="justify-items-center">
            <XIcon size={24} color="black" />
            <span className="text-xs text-background">Fechar</span>
          </div>
        </Button>
      </DialogContent>
    </Dialog>
  );
};
QRCodeDialog.displayName = "QRCodeDialog";
export default QRCodeDialog;
